export const cn = (...opts) => opts.filter((opt) => !!opt).join(" ");

export const getMapPageUrl = ({ place, search }) => {
    const params = new URLSearchParams({
        lat: place.geometry?.location?.lat,
        lng: place.geometry?.location?.lng,
        search: encodeURIComponent(search),
    });

    return `/find-a-clinic?${params.toString()}`;
};
